export const BREAKDOWN_TITLE_ID = "BreakdownTitleId";
export const BREAKDOWN_HEADER_ID = "BreakdownHeaderId";
export const BREAKDOWN_SUBHEADER_ID = "BreakdownSubheaderId";
export const SIX_PILLARS_WELLBEING_RESULT_HELPTEXT_ID =
  "SixPillarsWellbeingResultHelptextId";
